//bao migrate skip
import TabPage from "./tab-page";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoMenu from "./../services/bao-menu";
import BaseViewModel2 from "./base-view-model2";
import BaoDialogViewModel from "./bao-dialog";
import * as $ from "jquery";
class SearchPaging extends BaseViewModel2 {
    InitUrl(): string {
        return "";
    }
    CompleteCheck(): boolean | JQueryPromise<boolean> {
       return true;
    }
    constructor(tabPage: TabPage) {
        super(tabPage);
        this.SearchedEvent = $.proxy(this.SearchedEvent, this);
        Bao.bindEvent("searched", this.SearchedEvent);
        //subscribes
        this.subscribe(this.TabName, (value: string) => {
            if (value != "") {
                if (this.SearchPagingActive() && this.CurrentSearchIndex() != null && this.BackwardVisible() == null && this.ForwardVisible() == null) {
                    tabPage.Title(value + " (" + (this.CurrentSearchIndex() + 1) + " / " + this.CurrentTotalCount() + ")");
                }
                else {
                    tabPage.Title(value);
                }
            }
        });
        this.subscribe(this.CurrentSearchIndex, () => {
            this.SearchIndexChanged();
        });
        this.subscribe(this.ForwardVisible, () => {
            this.SearchIndexChanged();
        });
        this.subscribe(this.BackwardVisible, () => {
            this.SearchIndexChanged();
        });
        this.subscribe(this.SearchPagingActive, (item) => {
            if (item == true) {
                this.CurrentSearchIndex.valueHasMutated();
            }
        });
        this.Destroy.push(() => {
            Bao.unbindEvent("searched", this.SearchedEvent);
        });
        this.TabPage.MenuEvents.push(BaoMenu.registerEvent((value) => {
            if (this.TabPage.IsActiveTab() === true) {
                switch (value.ActionKey()) {
                    case this.PermissionForward:
                        this.MoveSearch(this.CurrentSearchIndex() + 1, "forward");
                        break;
                    case this.PermissionBackward:
                        this.MoveSearch(this.CurrentSearchIndex() - 1, "backward");
                        break;
                }
            }
        }));
    }
    SearchId = ko.observable<string>();
    BackwardVisible = ko.observable<boolean>();
    ForwardVisible = ko.observable<boolean>();
    CurrentTotalCount = ko.observable<number>();
    CurrentSearchIndex = ko.observable<number>();
    SearchPagingActive = ko.observable<boolean>(true);
    DisplayNumbers = ko.observable<boolean>(true);
    TabName = ko.observable<string>();
    TempNewIndex = null;
    PermissionForward = "";
    PermissionBackward = "";
    SearchIndexChanged() {
        var backVisible = (this.CurrentSearchIndex() > 0 && this.BackwardVisible() == null) || this.BackwardVisible();
        var forwardVisible = (this.CurrentSearchIndex() + 1 < this.CurrentTotalCount() && this.ForwardVisible() == null) || this.ForwardVisible();
        BaoMenu.permissionEnable({ ActionKey: this.PermissionBackward, Enabled: backVisible, Context: this.TabPage.Context() });
        BaoMenu.permissionEnable({ ActionKey: this.PermissionForward, Enabled: forwardVisible, Context: this.TabPage.Context() });
        BaoMenu.permissionVisible({ ActionKey: this.PermissionBackward, Visible: true, Context: this.TabPage.Context() });
        BaoMenu.permissionVisible({ ActionKey: this.PermissionForward, Visible: true, Context: this.TabPage.Context() });
        this.TabPage.DirtyFlag.pause();
        this.TabName.valueHasMutated();
        this.TabPage.DirtyFlag.resume();
    }
    ;
    SearchedEvent() {
        BaoMenu.permissionVisible({ ActionKey: this.PermissionForward, Visible: false, Context: this.TabPage.Context() });
        BaoMenu.permissionVisible({ ActionKey: this.PermissionBackward, Visible: false, Context: this.TabPage.Context() });
        this.SearchPagingActive(false);
        this.TabPage.DirtyFlag.pause();
        this.TabName.valueHasMutated();
        this.TabPage.DirtyFlag.resume();
        Bao.unbindEvent("searched", this.SearchedEvent);
    }
    ;
    MoveSearch(newIndex, mode) {
        if ((newIndex >= 0 && newIndex < this.CurrentTotalCount()) || (mode == "forward" && this.ForwardVisible()) || (mode == "backward" && this.BackwardVisible())) {
            if (this.TabPage.DirtyFlag() && (this.SaveAllowed == null || this.SaveAllowed())) {
                this.TabPage.IsLoading(false);
                var questionDialog = new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgSaveCheck"), "question");
                questionDialog.DialogResult.subscribe((result) => {
                    if (result === true) {
                        this.DeferredCompleteCheck().then((result) => {
                            if (result == true) {
                                $.when(this.Save()).then(() => {
                                    this.PerformMoveSearch(newIndex, mode);
                                });
                            }
                        });
                    }
                    else if (result === false) {
                        this.PerformMoveSearch(newIndex, mode);
                    }
                });
            }
            else {
                this.PerformMoveSearch(newIndex, mode);
            }
        }
    }
    PerformMoveSearch(newIndex, mode) {
        this.TempNewIndex = newIndex;
        this.TabPage.IsLoading(true);
        window.baorequire(["Services/AppTabController"], (AppTabController) => {
            var searchTab = AppTabController.SearchTabByObjectId("Search");
            if (searchTab != null) {
                searchTab.ViewModel().GetSearchItem(newIndex, this, mode).then((searchItem) => {
                    if (this.TabPage.IsActiveTab() == true) {
                        var tabFound = AppTabController.SearchTabByObjectId(searchItem.PrimaryKeyValue);
                        if (tabFound != null) {
                            setTimeout(() => {
                                tabFound.ViewModel().CurrentTotalCount(this.CurrentTotalCount());
                                tabFound.ViewModel().CurrentSearchIndex(this.TempNewIndex);
                                tabFound.ViewModel().SearchPagingActive(true);
                                AppTabController.SelectTab(tabFound);
                                this.TabPage.IsLoading(false);
                            }, 0);
                        }
                        else {
                            this.SetSearchMovedItem(searchItem);
                        }
                    }
                });
            }
        });
    }
    SetSearchMovedItem(searchItem) {
        this.TabPage.DirtyFlag.reset();
        this.TabPage.DirtyFlag.pause();
        this.CurrentSearchIndex(this.TempNewIndex);
        this.TabPage.DirtyFlag.pause();
        if (this.PrimaryKeyName() != null && searchItem != null && searchItem[this.PrimaryKeyName()] != null) {
            let pk = searchItem[this.PrimaryKeyName()];
            this[this.PrimaryKeyName()](pk);
            this[this.PrimaryKeyName()](pk);
            this.TabPage.ObjectId(pk);
            this.PrimaryKeyValue(pk);
            //this.OpenData(pk); not needed anymore in BaseViewModel2 ????
        }
        this.PerformRefresh();
        this.TabPage.DirtyFlag.resume();
    }
    ;
    InitPaging() {
        var searchObject;
        if (this.TabPage.Object != null && this.TabPage.Object.searchObject != null) {
            searchObject = this.TabPage.Object.searchObject;
        }
        else if (Bao != null && Bao["Search"] != null && Bao["Search"].CurrentSearchObject != null && Bao["Search"].CurrentSearchObject.id != null
            && ko.unwrap(this.PrimaryKeyValue) == Bao["Search"].CurrentSearchObject.id) {
            searchObject = Bao["Search"].CurrentSearchObject;
        }
        if (searchObject != null) {
            this.CurrentTotalCount(searchObject.totalCount);
            this.CurrentSearchIndex(searchObject.rowIndex);
            this.SearchId(searchObject.id);
            if (searchObject.forwardVisible != null) {
                this.ForwardVisible(searchObject.forwardVisible);
            }
            if (searchObject.backwardVisible != null) {
                this.BackwardVisible(searchObject.backwardVisible);
            }
        }
        else {
            BaoMenu.permissionVisible({ ActionKey: this.PermissionForward, Visible: false, Context: this.TabPage.Context() });
            BaoMenu.permissionVisible({ ActionKey: this.PermissionBackward, Visible: false, Context: this.TabPage.Context() });
            this.SearchPagingActive(false);
        }
    }
    ;
    loaded() {
        this.InitPaging();
        this.TabPage.DirtyFlag.reset();
        this.TabPage.IsLoading(false);
        this.Focus();
    }
    ;
}
export default SearchPaging;